
import { getProjectsOverviewRequest } from "@/services/ObjectService"
import { Vue } from "vue-class-component"

export default class Projects extends Vue {
	headline = "Kontakte konfigurieren"
	projects: any = []
	
	nextStep(projectId: any) {
		this.$router.push({ name: 'InterventionsAllOrIndividual', params: { id: projectId } })
	}
	
	beforeMount() {
		getProjectsOverviewRequest().then((res: any) => {
			if ( res.status === "OK" ) {
				this.projects = res.result.projekte
			}
		})
	}
}
